<template>
  <div>
    <md-dialog
      :md-active="internalDialogVisible"
      @update:mdActive="handleDialogActive"
      style="max-width: 60rem; margin: auto"
    >
      <md-dialog-title>Sell Appliance</md-dialog-title>
      <md-dialog-content
        style="overflow-y: auto"
        class="md-layout-item md-size-100"
      >
        <div v-if="loading">
          <loader />
        </div>
        <div v-else>
          <md-tabs>
            <md-tab
              id="count-based"
              @click="tabName = 'count-based'"
              md-label="Installment Count Based"
            >
              <form
                data-vv-scope="count-based-form"
                class="md-layout md-gutter"
              >
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-field
                    :class="{
                      'md-invalid': errors.has('count-based-form.appliance'),
                    }"
                  >
                    <label for="appliance">
                      {{ $tc("words.appliance") }}
                    </label>
                    <md-select
                      name="appliance"
                      id="appliance"
                      v-model="selectedApplianceId"
                      v-validate="'required'"
                    >
                      <md-option disabled value>
                        --{{ $tc("words.select") }}--
                      </md-option>
                      <md-option
                        :value="appliance.id"
                        v-for="appliance in applianceService.list"
                        :key="appliance.id"
                      >
                        {{ appliance.name }}
                      </md-option>
                    </md-select>

                    <span class="md-error">
                      {{ errors.first("count-based-form.appliance") }}
                    </span>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-field
                    :class="{
                      'md-invalid': errors.has('count-based-form.cost'),
                    }"
                  >
                    <label for="cost">
                      {{ $tc("words.cost") }}
                    </label>
                    <md-input
                      type="number"
                      name="cost"
                      id="cost"
                      v-model="applianceService.appliance.cost"
                      @keyup="checkDownPayment"
                      v-validate="'required|decimal'"
                    />
                    <span class="md-error">
                      {{ errors.first("count-based-form.cost") }}
                    </span>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-field
                    :class="{
                      'md-invalid': errors.has('count-based-form.down_payment'),
                    }"
                  >
                    <label for="down_payment">Down Payment</label>
                    <md-input
                      type="number"
                      name="down_payment"
                      id="down_payment"
                      min="0"
                      v-model="applianceService.appliance.downPayment"
                      v-validate="'required|min_value:0|decimal'"
                      @keyup="checkDownPayment"
                    />
                    <span class="md-error">
                      {{ errors.first("count-based-form.down_payment") }}
                    </span>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-field
                    :class="{
                      'md-invalid': errors.has('count-based-form.rate_type'),
                    }"
                  >
                    <label for="rate_type">
                      {{ $tc("phrases.rateType") }}
                    </label>
                    <md-select
                      name="rate_type"
                      id="rate_type"
                      v-model="applianceService.appliance.rateType"
                      v-validate="'required'"
                    >
                      <md-option value="weekly">
                        {{ $tc("words.week", 2) }}
                      </md-option>
                      <md-option value="monthly">
                        {{ $tc("words.month", 2) }}
                      </md-option>
                    </md-select>
                    <span class="md-error">
                      {{ errors.first("count-based-form.rate_type") }}
                    </span>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-field
                    :class="{
                      'md-invalid': errors.has(
                        'count-based-form.installment_count',
                      ),
                    }"
                  >
                    <label for="rate">
                      {{ $tc("phrases.ratesCount") }}
                    </label>
                    <md-input
                      type="number"
                      name="installment_count"
                      id="installment_count"
                      v-model="applianceService.appliance.rate"
                      v-validate="'required|integer'"
                    />
                    <span class="md-error">
                      {{ errors.first("count-based-form.rate") }}
                    </span>
                  </md-field>
                </div>
              </form>
            </md-tab>
            <md-tab
              id="cost-based"
              @click="tabName = 'cost-based'"
              md-label="Installment Cost Based"
            >
              <form data-vv-scope="cost-based-form" class="md-layout md-gutter">
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-field
                    :class="{
                      'md-invalid': errors.has('cost-based-form.appliance'),
                    }"
                  >
                    <label for="appliance">
                      {{ $tc("words.appliance") }}
                    </label>
                    <md-select
                      name="appliance"
                      id="appliance"
                      v-model="selectedApplianceId"
                      v-validate="'required'"
                    >
                      <md-option disabled value>
                        --{{ $tc("words.select") }}--
                      </md-option>
                      <md-option
                        :value="appliance.id"
                        v-for="appliance in applianceService.list"
                        :key="appliance.id"
                      >
                        {{ appliance.name }}
                      </md-option>
                    </md-select>
                    <span class="md-error">
                      {{ errors.first("cost-based-form.appliance") }}
                    </span>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-field
                    :class="{
                      'md-invalid': errors.has('cost-based-form.cost'),
                    }"
                  >
                    <label for="cost">
                      {{ $tc("words.cost") }}
                    </label>
                    <md-input
                      type="number"
                      name="cost"
                      id="cost"
                      v-model="applianceService.appliance.cost"
                      @keyup="checkDownPayment"
                      v-validate="'required|decimal'"
                    />
                    <span class="md-error">
                      {{ errors.first("cost-based-form.cost") }}
                    </span>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-field
                    :class="{
                      'md-invalid': errors.has('cost-based-form.down_payment'),
                    }"
                  >
                    <label for="down_payment">Down Payment</label>
                    <md-input
                      type="number"
                      name="down_payment"
                      id="down_payment"
                      v-validate="'required|min_value:0|decimal'"
                      v-model="applianceService.appliance.downPayment"
                      min="0"
                      @keyup="checkDownPayment"
                    />
                    <span class="md-error">
                      {{ errors.first("cost-based-form.down_payment") }}
                    </span>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-field
                    :class="{
                      'md-invalid': errors.has('cost-based-form.rate_type'),
                    }"
                  >
                    <label for="rate_type">
                      {{ $tc("phrases.rateType") }}
                    </label>
                    <md-select
                      name="rate_type"
                      id="rate_type"
                      v-model="applianceService.appliance.rateType"
                      v-validate="'required'"
                    >
                      <md-option value="weekly">
                        {{ $tc("words.week", 2) }}
                      </md-option>
                      <md-option value="monthly">
                        {{ $tc("words.month", 2) }}
                      </md-option>
                    </md-select>
                    <span class="md-error">
                      {{ errors.first("cost-based-form.rate_type") }}
                    </span>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-field
                    :class="{
                      'md-invalid': errors.has(
                        'cost-based-form.installment_cost',
                      ),
                    }"
                  >
                    <label for="installment_cost">
                      {{
                        $tc("words.rateCost", 1, {
                          rateType: applianceService.appliance.rateType,
                        })
                      }}
                    </label>
                    <md-input
                      type="number"
                      name="installment_cost"
                      id="installment_cost"
                      @keyup="calculateRateCountsOnRateCostChange"
                      v-model="applianceService.appliance.rateCost"
                      v-validate="'required|decimal'"
                    />
                    <span class="md-error">
                      {{ errors.first("cost-based-form.installment_cost") }}
                    </span>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-100 md-small-size-100">
                  <md-field>
                    <label for="minimumPayableAmount">
                      {{
                        applianceService.appliance.rateType === "weekly"
                          ? $tc("phrases.minimumPayableAmount", 1)
                          : $tc("phrases.minimumPayableAmount", 2)
                      }}
                    </label>
                    <md-input
                      type="number"
                      id="minimumPayableAmount"
                      name="minimumPayableAmount"
                      v-model="minimumPayableAmount"
                      readonly
                      disabled
                    />
                  </md-field>
                </div>
              </form>
            </md-tab>
            <md-tab
              id="energy-service"
              @click="tabName = 'energy-service'"
              md-label="Energy as a Service"
            >
              <form
                data-vv-scope="energy-service-form"
                class="md-layout md-gutter"
              >
                <div class="md-layout-item md-size-100 md-small-size-100">
                  <md-field
                    :class="{
                      'md-invalid': errors.has('energy-service-form.appliance'),
                    }"
                  >
                    <label for="appliance">
                      {{ $tc("words.appliance") }}
                    </label>
                    <md-select
                      name="appliance"
                      id="eaas-appliance"
                      v-model="selectedApplianceId"
                      v-validate="'required'"
                    >
                      <md-option disabled value>
                        --{{ $tc("words.select") }}--
                      </md-option>
                      <md-option
                        :value="appliance.id"
                        v-for="appliance in applianceService.list"
                        :key="appliance.id"
                      >
                        {{ appliance.name }}
                      </md-option>
                    </md-select>
                    <span class="md-error">
                      {{ errors.first("energy-service-form.appliance") }}
                    </span>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-field>
                    <label>{{ $tc("phrases.downPayment") }}</label>
                    <md-input
                      name="eaas-down-payment"
                      type="number"
                      min="0"
                      v-model="applianceService.appliance.downPayment"
                    />
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-field
                    :class="{
                      'md-invalid': errors.has(
                        'energy-service-form.price_per_day',
                      ),
                    }"
                  >
                    <label>{{ $tc("phrases.pricePerDay") }}</label>
                    <md-input
                      name="price_per_day"
                      type="number"
                      min="0"
                      v-model="pricePerDay"
                      v-validate="'required|min_value:0|decimal'"
                    />
                    <span class="md-error">
                      {{ errors.first("energy-service-form.price_per_day") }}
                    </span>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-field>
                    <label>{{ $tc("phrases.minimumPayableAmount", 0) }}</label>
                    <md-input
                      name="eaas-minimum-payable-amount"
                      type="number"
                      min="0"
                      v-model="minimumPayableAmount"
                    />
                  </md-field>
                  <span v-if="eaasMinPaymentDaysText" class="eaas-helper-text">
                    {{ eaasMinPaymentDaysText }}
                  </span>
                </div>
                <div class="md-layout-item md-size-100 md-small-size-100">
                  <p class="eaas-description">
                    {{ $tc("phrases.eaasDescription") }}
                  </p>
                </div>
              </form>
            </md-tab>
          </md-tabs>
          <div class="md-layout-item md-size-100 md-small-size-100">
            <template v-if="isDeviceSelectionRequired">
              <md-field
                :class="{
                  'md-invalid': errors.has($tc('phrases.selectDevice')),
                }"
              >
                <label>
                  {{ $tc("phrases.selectDevice") }}
                </label>
                <md-select
                  :name="$tc('phrases.selectDevice')"
                  v-model="selectedDeviceSerial"
                  v-validate="'required'"
                  @md-opened="focusDeviceSearchInput"
                  @md-closed="resetDeviceSearch"
                >
                  <div class="device-search-row" @click.stop @mousedown.stop>
                    <md-field md-inline>
                      <md-icon>search</md-icon>
                      <md-input
                        ref="deviceSearchInput"
                        v-model="deviceSearchTerm"
                        placeholder="Search by serial..."
                        @click.native.stop
                        @mousedown.native.stop
                        @keydown.native.stop
                      />
                    </md-field>
                  </div>
                  <template v-if="isDeviceSearching">
                    <md-option disabled>Searching…</md-option>
                  </template>
                  <template v-else-if="!deviceSelectionList.length">
                    <md-option disabled>
                      <md-tooltip md-direction="top">
                        Consider changing the search term or create a suitable
                        device first.
                      </md-tooltip>
                      No available device found.
                    </md-option>
                  </template>
                  <template v-else>
                    <md-option
                      v-for="device in deviceSelectionList"
                      :key="device.id"
                      :value="device.serial"
                    >
                      {{ device.serial }}
                    </md-option>
                  </template>
                </md-select>
                <span class="md-error">
                  {{ errors.first($tc("phrases.selectDevice")) }}
                </span>
              </md-field>
            </template>
            <DeviceLocationField
              v-model="deviceLocation"
              :fallback-location="fallbackDeviceLocation"
              :marker-icon="getMarkerIconForAppliance(currentAppliance)"
            />
          </div>
          <InstallmentRateSummary
            v-if="
              applianceService.appliance.rate && tabName !== 'energy-service'
            "
            :cost="applianceService.appliance.cost"
            :down-payment="applianceService.appliance.downPayment"
            :rate-count="applianceService.appliance.rate"
            :show-rates="showRates"
          />
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button
          v-if="showRatesButton"
          class="md-accent md-raised"
          @click="showRates = !showRates"
        >
          Show Rates Detail
        </md-button>
        <md-button
          type="button"
          class="md-primary md-raised"
          @click="saveAppliance"
        >
          {{ $tc("words.sell") }}
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import defaultMarker from "leaflet/dist/images/marker-icon.png"
import { mapGetters } from "vuex"

import { ErrorHandler } from "@/Helpers/ErrorHandler.js"
import {
  hasCoordinates,
  locationToPoints,
  parseGeoLocation,
} from "@/Helpers/Utils.js"
import { currency } from "@/mixins/currency.js"
import { notify } from "@/mixins/notify.js"
import { AppliancePersonService } from "@/services/AppliancePersonService.js"
import { ApplianceService } from "@/services/ApplianceService.js"
import { DeviceService } from "@/services/DeviceService.js"
import { ICONS } from "@/services/MappingService.js"
import DeviceLocationField from "@/shared/DeviceLocationField.vue"
import InstallmentRateSummary from "@/shared/InstallmentRateSummary.vue"
import Loader from "@/shared/Loader.vue"

const debounce = require("debounce")

const APPLIANCE_TYPE_SHS_ID = 1
const APPLIANCE_TYPE_E_BIKE_ID = 2
export default {
  name: "SellApplianceModal",
  mixins: [currency, notify],
  components: {
    Loader,
    DeviceLocationField,
    InstallmentRateSummary,
  },
  props: {
    showSellApplianceModal: {
      required: true,
      type: Boolean,
    },
    person: {
      required: true,
    },
  },
  data() {
    return {
      applianceService: new ApplianceService(),
      appliancePersonService: new AppliancePersonService(),
      deviceService: new DeviceService(),
      selectedApplianceId: null,
      deviceSelectionList: [],
      isDeviceSelectionRequired: false,
      minimumPayableAmount: 0,
      pricePerDay: 0,
      selectedDeviceSerial: null,
      showRates: false,
      loading: false,
      tabName: "count-based",
      deviceLocation: null,
      internalDialogVisible: false,
      deviceSearchTerm: "",
      isDeviceSearching: false,
    }
  },
  created() {
    this.internalDialogVisible = this.showSellApplianceModal
  },
  beforeMount() {
    this.getApplianceList()
  },
  methods: {
    getMarkerIconForAppliance(appliance) {
      if (!appliance) {
        return defaultMarker
      }
      switch (appliance.applianceTypeId) {
        case APPLIANCE_TYPE_SHS_ID:
          return ICONS.SHS
        case APPLIANCE_TYPE_E_BIKE_ID:
          return ICONS.E_BIKE
        default:
          return ICONS.METER
      }
    },
    handleDialogActive(value) {
      this.internalDialogVisible = value
      if (!value) {
        this.$emit("hideModal")
      }
    },
    async getApplianceList() {
      try {
        await this.applianceService.getAppliances()
      } catch (e) {
        this.alertNotify("error", e.message)
      }
    },
    async saveAppliance() {
      const formName = `${this.tabName}-form`
      const validator = await this.$validator.validateAll(formName)
      if (!validator) return
      const appliance = this.applianceService.list.find(
        (x) => x.id === this.applianceService.appliance.id,
      )
      const isEnergyService = this.tabName === "energy-service"
      const isDeviceBindingRequired = this.isDeviceBindingRequired(appliance)
      if (isDeviceBindingRequired && !this.selectedDeviceSerial) {
        this.alertNotify("error", "Please select a device")
        return
      }
      const locationPoints = this.getGeoPointsForAppliance()
      if (!locationPoints) {
        this.alertNotify("error", "Please set the device location")
        return
      }
      const confirmText = isEnergyService
        ? this.$tc("phrases.confirmEaas")
        : this.$tc("phrases.sellAppliance", 2, {
            cost: this.moneyFormat(this.applianceService.appliance.cost),
          })
      this.$swal({
        type: "question",
        title: this.$tc("phrases.sellAppliance", 0),
        text: confirmText,
        showCancelButton: true,
        cancelButtonText: this.$tc("words.cancel"),
        confirmButtonText: this.$tc("words.sell"),
      }).then(async (result) => {
        if (result.value) {
          try {
            this.loading = true
            const points = locationPoints
            const soldApplianceParams = {
              id: this.applianceService.appliance.id,
              personId: this.person.id,
              ...this.applianceService.appliance,
              cost: isEnergyService ? 0 : this.applianceService.appliance.cost,
              downPayment: this.applianceService.appliance.downPayment || 0,
              rate: isEnergyService ? 0 : this.applianceService.appliance.rate,
              paymentType: isEnergyService ? "energy_service" : "installment",
              minimumPayableAmount: isEnergyService
                ? this.minimumPayableAmount || null
                : null,
              pricePerDay: isEnergyService ? this.pricePerDay || null : null,
              points: points,
              userId: this.user.id,
              deviceSerial: this.selectedDeviceSerial,
            }
            const soldAppliance =
              await this.appliancePersonService.sellAppliance(
                soldApplianceParams,
              )
            this.alertNotify("success", this.$tc("phrases.sellAppliance", 1))
            const appliancePersonId =
              soldAppliance.appliancePerson?.id ?? soldAppliance.id
            const downPayment = Number(soldApplianceParams.downPayment)
            await this.$router.push({
              path: "/sold-appliance-detail/" + appliancePersonId,
              query: downPayment > 0 ? { payment: downPayment } : {},
            })
          } catch (e) {
            console.log(e)
            this.alertNotify("error", e.message)
          }
          this.loading = false
        }
      })
    },
    getGeoPointsForAppliance() {
      if (hasCoordinates(this.deviceLocation)) {
        return locationToPoints(this.deviceLocation)
      }
      if (!this.fallbackDeviceLocation) return null
      const [lat, lon] = this.fallbackDeviceLocation

      return `${lat},${lon}`
    },
    getSelectedAddress() {
      const addresses = this.person.addresses || []
      if (!addresses.length) return null
      const primaryAddress = addresses.find(
        (address) => address.isPrimary || address.is_primary,
      )
      return primaryAddress || addresses[0]
    },
    resetDeviceSelectionValidation() {
      const fieldName = this.$tc("phrases.selectDevice")
      if (
        this.errors &&
        typeof this.errors.has === "function" &&
        this.errors.has(fieldName)
      ) {
        this.errors.remove(fieldName)
      }
      if (this.$validator && typeof this.$validator.reset === "function") {
        this.$validator.reset(fieldName)
      }
    },
    checkDownPayment() {
      if (
        parseFloat(this.applianceService.appliance.downPayment) >
        parseFloat(this.applianceService.appliance.cost)
      ) {
        this.applianceService.appliance.downPayment = 0
        this.alertNotify(
          "warn",
          "Down Payment is not bigger than Appliance Cost",
        )
      } else if (
        this.applianceService.appliance.cost ===
        this.applianceService.appliance.downPayment
      ) {
        this.applianceService.appliance.rate = 0
      }
      this.minimumPayableAmount = 0
      this.rateCost = 0
    },
    calculateRateCountsOnRateCostChange() {
      const remainingCost =
        parseFloat(this.applianceService.appliance.cost) -
        parseFloat(this.applianceService.appliance.downPayment)
      const installmentCost = Number(this.applianceService.appliance.rateCost)
      if (installmentCost > remainingCost) {
        this.alertNotify(
          "warn",
          "Rate cost can not be bigger than remaining cost",
        )
        this.minimumPayableAmount = 0
        this.applianceService.appliance.rate = 0
        return
      }
      if (installmentCost < 1 || typeof installmentCost !== "number") {
        this.minimumPayableAmount = 0
        this.applianceService.appliance.rate = 0
        return
      }
      this.minimumPayableAmount = Math.floor(installmentCost)
      this.applianceService.appliance.rate = Math.floor(
        remainingCost / this.minimumPayableAmount,
      )
    },
    isDeviceBindingRequired(appliance) {
      if (!appliance) return false
      return (
        appliance.applianceTypeId === APPLIANCE_TYPE_SHS_ID ||
        appliance.applianceTypeId === APPLIANCE_TYPE_E_BIKE_ID
      )
    },
    focusDeviceSearchInput() {
      this.$nextTick(() => {
        const input = this.$refs.deviceSearchInput
        if (input && typeof input.focus === "function") {
          input.focus()
        }
      })
    },
    resetDeviceSearch() {
      this.deviceSearchTerm = ""
    },
    async loadDevicesForAppliance(serial = null) {
      this.isDeviceSearching = true
      const result = await this.deviceService.getAvailableDevicesForAppliance(
        this.selectedApplianceId,
        serial,
      )
      this.isDeviceSearching = false
      if (result instanceof ErrorHandler) {
        this.deviceSelectionList = []
        return
      }
      this.deviceSelectionList = this.deviceService.list.map((device) => ({
        id: device.id,
        serial: device.deviceSerial,
      }))
    },
  },
  computed: {
    ...mapGetters({
      settings: "settings/getMainSettings",
      user: "auth/getAuthenticateUser",
    }),
    currentAppliance() {
      return (
        this.applianceService.list.find(
          (x) => x.id === this.applianceService.appliance.id,
        ) || null
      )
    },
    showRatesButton() {
      return this.applianceService.appliance.rate > 1
    },
    // where the device sits until someone picks a spot on the map
    fallbackDeviceLocation() {
      const address = this.getSelectedAddress()
      if (!address) return null

      return (
        parseGeoLocation(address.geo) ??
        parseGeoLocation(address.city?.location)
      )
    },
    eaasMinPaymentDaysText() {
      const amount = parseFloat(this.minimumPayableAmount)
      const rate = parseFloat(this.pricePerDay)
      if (!amount || !rate || rate <= 0) return ""
      const days = Math.round((amount / rate) * 10) / 10
      return `= ${days} day${days !== 1 ? "s" : ""} of service at ${this.moneyFormat(rate)}/day`
    },
  },
  watch: {
    deviceSearchTerm: debounce(function () {
      if (!this.isDeviceSelectionRequired || !this.selectedApplianceId) return
      this.loadDevicesForAppliance(this.deviceSearchTerm.trim() || null)
    }, 300),
    showSellApplianceModal(value) {
      this.internalDialogVisible = value
    },
    async selectedApplianceId() {
      this.applianceService.appliance.id = this.selectedApplianceId
      const appliance = this.applianceService.list.find(
        (x) => x.id === this.applianceService.appliance.id,
      )
      if (this.isDeviceBindingRequired(appliance)) {
        this.isDeviceSelectionRequired = true
        this.selectedDeviceSerial = null
        this.deviceSearchTerm = ""
        this.resetDeviceSelectionValidation()
        await this.loadDevicesForAppliance()
      } else {
        this.isDeviceSelectionRequired = false
        this.deviceSelectionList = []
        this.selectedDeviceSerial = null
        this.resetDeviceSelectionValidation()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.coordinate-section {
  margin-top: 1rem;
}

.coordinate-button {
  margin-top: 0.5rem;
}

.coordinate-hint {
  font-size: 0.875rem;
  color: #666;
  margin-top: 0.5rem;
}

.coordinate-dialog-hint {
  font-size: 0.875rem;
  color: #555;
  margin-bottom: 1rem;
}

.eaas-helper-text {
  display: block;
  font-size: 0.8rem;
  color: #888;
  margin-top: -0.5rem;
  margin-bottom: 0.5rem;
}

.eaas-description {
  font-size: 0.875rem;
  color: #555;
  margin-top: 0.5rem;
  line-height: 1.5;
}

.device-search-row {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 0 1rem;
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
}
</style>
